export default __webpack_public_path__ + "static/media/pirate.5d1ebfd3.gif";